<template>
  <div class="h-full">
    <el-popover
      placement="bottom"
      :width="200"
      trigger="hover"
      :popper-style="{
        padding: '10px'
      }"
    >
      <template #reference>
        <div
          class="box-border flex h-full cursor-pointer items-center space-x-5 border-b-[3px] px-25 font-semibold transition-all hover:border-primary hover:bg-[#fff5e5] hover:text-primary"
          :class="[
            isMoreItemActive
              ? 'border-primary bg-[#fff5e5] text-primary'
              : 'border-white bg-white text-black-3'
          ]"
        >
          <span>其他服务</span>
          <span class="iconfont icon-caret-down" style="font-size: 16px" />
        </div>
      </template>
      <div class="grid grid-cols-2 gap-5">
        <NuxtLink
          :to="item.to"
          class="group flex cursor-pointer flex-col items-center space-y-5 py-10 transition-all hover:bg-[#f5f7fa]"
          :class="[
            currentPath === item.to
              ? 'bg-[#f5f7fa] text-primary'
              : 'bg-white text-black-4'
          ]"
          v-for="item in moreItems"
          :key="item.label"
        >
          <img :src="item.icon" class="h-36 w-36 object-cover" />
          <span class="text-base">{{ item.label }}</span>
        </NuxtLink>
      </div>
    </el-popover>
  </div>
</template>

<script setup>
import nav_bar_house from '~/assets/img/nav_bar/nav_bar_house.png'
import nav_bar_labour from '~/assets/img/nav_bar/nav_bar_labour.png'
import nav_bar_visa from '~/assets/img/nav_bar/nav_bar_visa.png'
import nav_bar_car from '~/assets/img/nav_bar/nav_bar_car.png'

const route = useRoute()

const currentPath = computed(() => route.fullPath)

const moreItems = [
  {
    icon: nav_bar_house,
    label: '买房卖房',
    to: '/house'
  },
  {
    icon: nav_bar_visa,
    label: '签证移民',
    to: '/visa'
  },
  {
    icon: nav_bar_car,
    label: '全球包车服务',
    to: '/car'
  }
  // {
  //   icon: nav_bar_labour,
  //   label: '出国劳务',
  //   to: '/labour'
  // }
]

const isMoreItemActive = computed(() =>
  moreItems.some((item) => item.to === currentPath.value)
)
</script>

<style lang="scss" scoped></style>
